import { Avatar, Empty } from "antd";
import dayjs from "dayjs";

export interface Activity {
  time: string;
  user: string;
  action: string;
  item: string;
  initials: string;
}

export interface ActivityTimelineProps {
  groupedActivities?: Record<string, { data: Activity[] }> | null;
  className?: string;
}

const ActivityStreamLine = ({
  groupedActivities,
  className = "",
}: ActivityTimelineProps) => {
  const dateEntries = groupedActivities
    ? Object.entries(groupedActivities)
    : [];

  if (!dateEntries.length) {
    return (
      <div
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Empty description="No data found" />
      </div>
    );
  }

  return (
    <div className={`activity-timeline ${className}`}>
      {dateEntries.map(([date, activities], dateIndex) => (
        <div key={dateIndex} style={{ marginBottom: 24 }}>
          {activities.data.map((activity, i) => {
            const isFirst = i === 0;

            return (
              <div
                key={i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: 16,
                }}
              >
                {/* Date label - only show for first activity of each date */}
                {isFirst && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      marginBottom: 12,
                      paddingBottom: 8,
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: "#1890ff",
                      }}
                    />
                    <span style={{ fontWeight: 600, color: "#1890ff", fontSize: 14 }}>
                      {date && dayjs(date).format("DD MMM YYYY")}
                    </span>
                  </div>
                )}

                {/* Activity item */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 12,
                    paddingLeft: 16,
                    borderLeft: "2px solid #e8e8e8",
                    marginLeft: 3,
                  }}
                >
                  {/* Time badge */}
                  <div
                    style={{
                      minWidth: 60,
                      padding: "4px 8px",
                      backgroundColor: "#f5f5f5",
                      borderRadius: 4,
                      fontSize: 12,
                      color: "#666",
                      textAlign: "center",
                      flexShrink: 0,
                    }}
                  >
                    {activity.time}
                  </div>

                  {/* Avatar */}
                  <Avatar
                    size={32}
                    style={{
                      backgroundColor: "#ff7875",
                      flexShrink: 0,
                    }}
                  >
                    <span style={{ color: "white", fontSize: 12 }}>
                      {activity.initials}
                    </span>
                  </Avatar>

                  {/* Content */}
                  <div style={{ flex: 1, lineHeight: 1.6 }}>
                    <strong style={{ color: "#333" }}>{activity.user}</strong>{" "}
                    <span style={{ color: "#666" }}>has</span>{" "}
                    <span
                      style={{
                        fontWeight: 600,
                        color: "#722ed1",
                        background: "#f9f0ff",
                        padding: "1px 8px",
                        borderRadius: "10px",
                        fontSize: "12px",
                      }}
                    >
                      {activity.action}
                    </span>{" "}
                    <span style={{ fontWeight: 600, color: "#333" }}>
                      {activity.item}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default ActivityStreamLine;
